import {
  SET_IS_AUTHENTICATED,
  SET_IS_DIRECT_SIGNUP,
  SET_IS_LOADING_SUBSCRIPTION_START,
  SET_IS_SUBSCRIBED,
  SET_PACKAGE_DETAILS_ARE_LOADED,
  SET_SELECTED_PACKAGE,
  SET_SHOW_SUBSCRIPTION_CODE_FIELD,
  SET_SUBSCRIPTION_CODE_INPUT,
  UPDATE_BILLING_INFO,
} from '../actions/billing';
import DEFAULT_STATE, { BillingState } from '../defaults/billing';
import createReducer from './create-reducer';

function updateBilling(state: BillingState, { payload }: { payload: BillingState }) {
  return {
    ...state,
    ...payload,
  };
}

function setIsAuthenticated(
  state: BillingState,
  { isAuthenticated }: { isAuthenticated: boolean },
) {
  return {
    ...state,
    isAuthenticated,
  };
}

const handlers = {
  [SET_IS_AUTHENTICATED]: setIsAuthenticated,
  [SET_IS_LOADING_SUBSCRIPTION_START]: updateBilling,
  [SET_PACKAGE_DETAILS_ARE_LOADED]: updateBilling,
  [SET_SELECTED_PACKAGE]: updateBilling,
  [UPDATE_BILLING_INFO]: updateBilling,
  [SET_IS_SUBSCRIBED]: updateBilling,
  [SET_IS_DIRECT_SIGNUP]: updateBilling,
  [SET_SHOW_SUBSCRIPTION_CODE_FIELD]: updateBilling,
  [SET_SUBSCRIPTION_CODE_INPUT]: updateBilling,
};

export default createReducer(DEFAULT_STATE, handlers);
